const columns = [
  {
    name: 'Country',
    selector: (row) => row.name,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
